// extracted by mini-css-extract-plugin
export default {"tooltip":"y1CqV8m","donutTooltip":"mRcPi7e","date":"onw7TPG","content":"kj0kA9A","lineLabel":"lcpEVMp","point":"vObuCiH","label":"MMo4V7Z","value":"noQTmPv"};